  function isIE () {
    return /Trident\/|MSIE/.test(window.navigator.userAgent)
  }

  function getOrientation (file, callback) {
    var reader = new FileReader()
    reader.onload = function (e) {
      var view = new DataView(e.target.result)
      if (view.getUint16(0, false) !== 0xFFD8) {
        return callback(-2)
      }
      var length = view.byteLength
      var offset = 2
      while (offset < length) {
        if (view.getUint16(offset + 2, false) <= 8) return callback(-1)
        var marker = view.getUint16(offset, false)
        offset += 2
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) {
            return callback(-1)
          }
          var little = view.getUint16(offset += 6, false) === 0x4949
          offset += view.getUint32(offset + 4, little)
          var tags = view.getUint16(offset, little)
          offset += 2
          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              return callback(view.getUint16(offset + (i * 12) + 8, little))
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) {
          break
        } else {
          offset += view.getUint16(offset, false)
        }
      }
      return callback(-1)
    }
    reader.readAsArrayBuffer(file)
  }

  function setTransformations (canvas, scale, srcOrientation, cb) {
    var width = canvas.width * scale
    var height = canvas.height * scale
    // set proper canvas dimensions before transform & export
    if (srcOrientation > 4 && srcOrientation < 9) {
      canvas.width = height
      canvas.height = width
    } else {
      canvas.width = width
      canvas.height = height
    }
    // transform context before drawing image
    var ctx = canvas.getContext('2d')
    switch (srcOrientation) {
      case 2: ctx.transform(-1, 0, 0, 1, width, 0)
        break
      case 3: ctx.transform(-1, 0, 0, -1, width, height)
        break
      case 4: ctx.transform(1, 0, 0, -1, 0, height)
        break
      case 5: ctx.transform(0, 1, 1, 0, 0, 0)
        break
      case 6: ctx.transform(0, 1, -1, 0, height, 0)
        break
      case 7: ctx.transform(0, -1, -1, 0, height, width)
        break
      case 8: ctx.transform(0, -1, 1, 0, 0, width)
        break
      default:
        break
    }
    ctx.transform(scale, 0, 0, scale, 0, 0)
    cb()
  }

  function compress (file, cb, props) {
    if ('image/jpeg, image/png, image/gif, image/ico, image/bmp, image/x-bmp'
      .toUpperCase().includes(file.type.toUpperCase())) {
      props = Object.assign({maxWidth: 1280, quality: 0.8}, props)
      var fr = new FileReader()
      fr.onload = e => {
        const img = new Image()
        img.onload = () => {
          getOrientation(file, (srcOrientation) => {
            const scale = props.maxWidth >= img.width ? 1 : props.maxWidth / img.width
            var canvas = document.createElement('canvas')
            document.body.appendChild(canvas)
            canvas.width = img.width
            canvas.height = img.height
            setTransformations(canvas, scale, srcOrientation, () => {
              var ctx = canvas.getContext('2d')
              ctx.drawImage(img, 0, 0)
              ctx.canvas.toBlob((blob) => {
                var filename = file.name.substring(0, file.name.lastIndexOf('.')) + '.jpg'
                const newFile = new File([blob], filename, {
                  type: 'image/jpeg',
                  lastModified: Date.now()
                })
                document.body.removeChild(canvas)
                cb(newFile)
              },
              'image/jpeg',
              props.quality)
            })
          })
        }
        img.src = e.target.result
      }
      fr.readAsDataURL(file)
    } else {
      cb(file)
    }
  }

  export default {
    copyContentToClipboard (html, text) {
      var res = false
      if (isIE()) {
        res = this.copyContentToClipboard1(html)
      } else {
        res = this.copyContentToClipboard2(html, text)
      }
      return res
    },
    copyContentToClipboard2 (html, text) {
      const modifyCopy = e => {
        if (text) {
          e.clipboardData.setData('text/plain', text)
        }
        if (html) {
          e.clipboardData.setData('text/html', html)
        }
        e.preventDefault()
      }
      var res = document.queryCommandSupported('copy')
      if (res) {
        document.addEventListener('copy', modifyCopy, {once: true})
        res = document.execCommand('copy')
        // If browser (safari Version 11.0.3 (13604.5.6)), could not copy without selection of any tag
        // we create and select new div with html and replace by our content in our listener
        if (!res) {
          res = this.copyContentToClipboard(html)
        }
      }
      return res
    },
    elementSelect (element) {
      this.elementDeSelect()
      if (document.selection) {
        var range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        var rangeNode = document.createRange()
        rangeNode.selectNode(element)
        window.getSelection().addRange(rangeNode)
      }
    },
    elementDeSelect () {
      if (document.selection) {
        document.selection.empty()
      } else if (window.getSelection) {
        window.getSelection().removeAllRanges()
      }
    },
    copyTextToClipboard (text) {
      var res = false
      var input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      res = document.execCommand('copy')
      document.body.removeChild(input)
      return res
    },
    copyElementToClipboard (element) {
      this.elementSelect(element)
      var res = document.execCommand('copy')
      this.elementDeSelect()
      return res
    },
    copyContentToClipboard1 (content) {
      var res = false
      try {
        var input = document.createElement('div')
        input.innerHTML = content
        document.body.appendChild(input)
        res = this.copyElementToClipboard(input)
      } finally {
        document.body.removeChild(input)
      }
      return res
    },
    copyHrefToClipboard (element) {
      element.style.display = 'block'
      var res = this.copyElementToClipboard(element)
      element.style.display = 'none'
      if (res) {
        alert('Ссылка на результаты скопирована в буфер обмена')
      } else {
        alert('К сожалению, Ваш браузер не позволяет автоматически копировать текст.\nВы можете самостоятельно скопировать ссылку из адресной строки браузера.')
      }
    },
    makepage (title, html) {
      return '<html>\n' +
      '<head>\n' +
      '<META http-equiv=Content-Type content="text/html; charset=utf-8">\n' +
      '<title>' + title + '</title>\n' +
      '</head>\n' +
      '<body>\n' +
      html +
      '</body>\n' +
      '</html>\n'
    },
    compress (file, cb, props) {
      compress(file, cb, props)
    }
  }



// WEBPACK FOOTER //
// ./src/api/utils.js